import axios from 'axios';
import PortalCredencialWebApiTokenInterceptor from './PortalCredencialWebApi/PortalCredencialWebApiTokenInterceptor';
import { success, error } from './PortalCredencialWebApi/PortalCredencialWebApiTokenValidateInterceptor';

const instance = axios.create();
const baseURL = process.env.VUE_APP_portalCredencialWebApiUrl

const headers = { 'X-Requested-With': 'XMLHttpRequest', 'X-XSS-Protection': '1; mode=block', 'X-Content-Type-Options': 'nosniff', 'Content-Security-Policy': "script-src 'self' scripts.apidev.kurierservicos.com.br/kportalcredenciaisdev; media-src 'self'; img src *; default-src 'self' https://*.apidev.kurierservicos.com.br/kportalcredenciaisdev" };

instance.interceptors.request.use(PortalCredencialWebApiTokenInterceptor)
instance.interceptors.response.use(success, error)

import PerfilPortalAPI from './PortalCredencialWebApi/PerfilPortalAPI';
import UsuarioWebAPI from './PortalCredencialWebApi/UsuarioWebAPI';
import StoreWebAPI from './PortalCredencialWebApi/StoreWebAPI';
import TermoAPI from './PortalCredencialWebApi/TermoAPI';
import CredencialWebAPI from './PortalCredencialWebApi/CredencialWebAPI';
import RelatorioWebAPI from './PortalCredencialWebApi/RelatorioWebAPI';
import CredenciaisInternasWebAPI from './PortalCredencialWebApi/CredenciaisInternasWebAPI';

export default {
    ...PerfilPortalAPI({instance, baseURL, headers}),    
    ...UsuarioWebAPI({instance, baseURL, headers}),
    ...StoreWebAPI({instance, baseURL, headers}),
    ...TermoAPI({instance, baseURL, headers}),
    ...CredencialWebAPI({instance, baseURL, headers}),
    ...CredenciaisInternasWebAPI({instance,baseURL,headers}),
    ...RelatorioWebAPI({instance, baseURL, headers}),
};